import { DashboardModule, Form, Grid } from '@domain-group/suit-theme'

import type { AgencyModel } from '@models/types'

interface ContactDetailsProps {
  agencySalesforceDetails: AgencyModel['salesforce_details'],
}

const ContactDetails = (props: ContactDetailsProps) => {
  const { agencySalesforceDetails } = props

  const contactDetailsPayload = [
    { label: 'Email', value: agencySalesforceDetails?.email },
    { label: 'Phone', value: agencySalesforceDetails?.phone },
    { label: 'Website', value: agencySalesforceDetails?.website },
  ]

  return (
    <DashboardModule title="Contact">
      <Grid
        // @ts-expect-error TS2322
        gridGap="large"
        gridTemplateColumns={[
          'repeat(1, minmax(160px, 1fr))',
          'repeat(1, minmax(160px, 1fr))',
          'repeat(1, minmax(160px, 1fr))',
          'repeat(2, minmax(160px, 1fr))',
        ]}
        padding="large"
      >
        {contactDetailsPayload.map(field => (
          <Form.Field label={field.label}>
            <input
              disabled
              type="text"
              value={field.value}
            />
          </Form.Field>
        ))}
      </Grid>
    </DashboardModule>
  )
}

export default ContactDetails
